import axios from "@/api/config";

const wxSchoolPageMenu = {
  getWxSchoolPageMenuById(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPageMenu/getWxSchoolPageMenuById/` +
        data,
      {}
    );
  },
  getWxSchoolPageMenuDetail(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPageMenu/getWxSchoolPageMenuDetail`,
      { params: data }
    );
  },
  getWxSchoolPageMenu(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPageMenu/getWxSchoolPageMenu`,
      { params: data }
    );
  },
  getWxSchoolPageMenuList(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPageMenu/getWxSchoolPageMenuList`,
      { params: data }
    );
  },
  getWxSchoolPageMenuTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPageMenu/getWxSchoolPageMenuTree`,
      { params: data }
    );
  },
  pageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/wxSchoolPageMenu/pageList`,
      data
    );
  },
  addWxSchoolPageMenu(data) {
    return axios.post(
      `${process.env.BASE_URL}/wxSchoolPageMenu/addWxSchoolPageMenu`,
      data
    );
  },
  updateWxSchoolPageMenu(data) {
    return axios.put(
      `${process.env.BASE_URL}/wxSchoolPageMenu/updateWxSchoolPageMenu`,
      data
    );
  },
  deleteWxSchoolPageMenu(data) {
    return axios.delete(
      `${process.env.BASE_URL}/wxSchoolPageMenu/deleteWxSchoolPageMenu`,
      { data: data }
    );
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPageMenu/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(
      `${process.env.BASE_URL}/wxSchoolPageMenu/importData`,
      data
    );
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPageMenu/active`, data);
  },
  enabled(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPageMenu/enabled`, data);
  }
};

export default wxSchoolPageMenu;



// WEBPACK FOOTER //
// ./src/api/wxSchoolPageMenu.js